import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Properties for the Confluence submit prompt on page create command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceSubmitPromptOnPageCreateCommandProperties extends CommandProperties {
	/**
	 * The prompt submitted by the user for page creation.
	 */
	userPrompt: string;
}
/**
 * A command sent by a bridge API client to submit a prompt.
 *
 * @summary {@link CommandProperties.senderId} sends the user prompt to {@link CommandProperties.receiverId} once per page creation.
 */
export const ConfluenceSubmitPromptOnPageCreateCommand: CommandConstructor<
	ConfluenceSubmitPromptOnPageCreateCommandProperties,
	SerializableValue
> = createCommand<ConfluenceSubmitPromptOnPageCreateCommandProperties>(
	'confluence-prompt-submit-on-page-create-command',
);
